export function canUseWindow() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
